<div class="title" mat-dialog-title>
    <span>Add Project ID and API Key</span>
    <img class="datasource-logo" src="https://rubii-images.s3.ap-southeast-2.amazonaws.com/dsp/seedooh.svg" alt="Seedooh">
</div>
<div class="dialog-body">
    <div class="body-content">
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Project ID</mat-label>
                <input matInput placeholder="Enter Project ID" formControlName="projectId" data-cy="seedooh-project-id-input">
                <mat-error
                    *ngIf="connectionForm.get('projectId').errors && (connectionForm.get('projectId').touched ||
                    connectionForm.get('projectId').dirty)">
                    Invalid Project ID</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>API Key</mat-label>
                <input type="password" matInput placeholder="Enter API Key" formControlName="seedoohApiKey" data-cy="seedooh-api-key-input">
                <mat-error
                    *ngIf="connectionForm.get('seedoohApiKey').errors && (connectionForm.get('seedoohApiKey').touched ||
                    connectionForm.get('seedoohApiKey').dirty)">
                    Invalid API Key</mat-error>
            </mat-form-field>
        </form>
        <div class="template">
            <a href="https://rubii-images.s3.ap-southeast-2.amazonaws.com/templates/seedooh.xlsx"
                target="_blank" data-cy="seedooh-template-link">Download a sample report</a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="seedooh-dialog-connect-btn">
            Connect
        </button>
    </div>
</div>
